const FRICTION = 0.18;

export default class CustomCursor {
  constructor($element) {
    // only on desktop
    const isFinePointer = matchMedia('(pointer: fine)').matches;
    if (!isFinePointer) return;

    this.$element = $element;
    this.$pointer = $element.querySelector('.customCursor__pointer');
    this.x = window.innerWidth * 3/4;
    this.y = window.innerHeight * 3/4;
    this.effectScale = 1;

    // create cursors
    this.trails = [
      new CursorTrail(20, 0.036),
      new CursorTrail(28, 0.033),
      new CursorTrail(36, 0.03),
      new CursorTrail(44, 0.027),
      new CursorTrail(52, 0.024),
    ];
    const $trailElements = this.trails.map((trail) => trail.$element);
    this.$element.append(...$trailElements);

    // over-bind methods
    this.onMousemove = this.onMousemove.bind(this);
    this.onMousedown = this.onMousedown.bind(this);
    this.onMouseup = this.onMouseup.bind(this);
    this.animate = this.animate.bind(this);

    document.addEventListener('mousemove', this.onMousemove);
    document.addEventListener('mousedown', this.onMousedown);
    document.addEventListener('mouseup', this.onMouseup);

    document.documentElement.classList.add('hasCustomCursor');

    this.isAnimating = true;
    this.animate();
  }

  onMousemove(event) {
    this.x = event.pageX - window.scrollX;
    this.y = event.pageY - window.scrollY;
    this.$pointer.style.transform = `translate(${this.x}px, ${this.y}px)`;
  }

  onMousedown() {
    this.effectScale = 0.5;
  }

  onMouseup() {
    this.effectScale = 1;
  }

  animate() {
    this.trails.forEach((trail) => {
      trail.animate(this.x, this.y, this.effectScale);
    });
    if (this.isAnimating) requestAnimationFrame(this.animate);
  }

  stopAnimation() {
    this.isAnimating = false;
  }

  unmount() {
    this.stopAnimation();
    document.documentElement.classList.remove('hasCustomCursor');
    document.removeEventListener('mousemove', this.onMousemove);
    document.removeEventListener('mousedown', this.onMousedown);
    document.removeEventListener('mouseup', this.onMouseup);
    this.trails.forEach((trail) => trail.$element.remove());
  }
}

// -------------------------- CursorTrail -------------------------- //

class CursorTrail {
  constructor(size, attractGamma) {
    this.$element = document.createElement('div');
    this.$element.className = 'customCursor__trail';

    this.$element.style.width = `${size}px`;
    this.$element.style.height = `${size}px`;
    this.$element.style.top = `-${size/2}px`;
    this.$element.style.left = `-${size/2}px`;

    this.attractGamma = attractGamma;
    this.x = window.innerWidth * 3/4;
    this.y = window.innerHeight * 3/4;
    this.scale = 1;
    this.velocityX = 0;
    this.velocityY = 0;
    this.velocityScale = 0;
  }

  animate(pointerX, pointerY, effectScale) {
    // apply attraction
    this.velocityX += (pointerX - this.x) * this.attractGamma;
    this.velocityY += (pointerY - this.y) * this.attractGamma;
    this.velocityScale += (effectScale - this.scale) * this.attractGamma;
    // integrate velocity
    this.x += this.velocityX;
    this.y += this.velocityY;
    this.scale += this.velocityScale;
    // apply friction
    this.velocityX *= 1 - FRICTION;
    this.velocityY *= 1 - FRICTION;
    this.velocityScale *= 1 - FRICTION;
    // render
    this.$element.style.transform = `translate(${this.x}px, ${this.y}px) scale(${this.scale})`;
  }
}
